import React from 'react';

import Link from 'next/link';

import { EXT_LINK } from '@services/http/ExtLink';

import css from './SocialMedia.module.scss';

const SocialMedia = () => {
    const socials = [
        {
            openInNewTab: true,
            icon: '/front-static/icons/action/fb.svg',
            link: EXT_LINK.FACEBOOK,
        },
        {
            openInNewTab: true,
            icon: '/front-static/icons/action/ig.svg',
            link: EXT_LINK.INSTAGRAM,
        },
        {
            openInNewTab: true,
            icon: '/front-static/icons/action/li.svg',
            link: EXT_LINK.LINKEDIN,
        },
        {
            openInNewTab: true,
            icon: '/front-static/icons/action/tk.svg',
            link: EXT_LINK.TIKTOK,
        },
    ];
    return (
        <div className={css.social_container}>
            {socials.map((social, index) => (
                <Link key={index} href={social.link} target={social.openInNewTab ? '_blank' : ''}>
                    <img src={social.icon} alt={`social-${index}`} />
                </Link>
            ))}
        </div>
    );
};

export default SocialMedia;
